<template>
  <div>
    <label for="status-code" v-if="detailed">Code</label>
    <b-alert :class="`text-dark ${variant}-alert`" show v-if="detailed">{{ statusCode }}: {{ statusText }}</b-alert>
    <hr v-if="detailed" />
    <label for="message">Message</label>
    <b-alert variant="secondary" show>{{ message }}</b-alert>
    <hr v-if="detailed" />
    <label for="timestamp" v-if="detailed">Timestamp</label>
    <b-alert variant="secondary" show v-if="detailed">{{ timestamp }}</b-alert>
    <hr v-if="detailed" />
    <label for="url" v-if="detailed">URL</label>
    <b-alert variant="secondary" show v-if="detailed">{{ url }}</b-alert>
    <hr v-if="content" />
    <label for="content" v-if="content">Content</label>
    <b-card v-if="content">{{ content }}</b-card>
  </div>
</template>

<script>
export default {
  props: {
    variant: { type: String, default: 'info' },
    statusCode: { type: [String, Number], default: 'NaN' },
    statusText: { type: String, default: 'Unknown Code' },
    timestamp: { type: String, default: new Date().toISOString() },
    message: { type: String, default: 'No message available' },
    content: { type: [Object, String], default: null },
    url: { type: String, default: 'No URL' },
    detailed: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.warning-alert {
  background-color: #FDA70078;
}
.danger-alert {
  background-color: #FD5F0078;
}
.info-alert {
  background-color: #1A86D078;
}
.success-alert {
  background-color: #21AE8C78;
}
</style>